// extracted by mini-css-extract-plugin
export default {"HeadCell":"HeadCell_HeadCell__68Y-g","HeadCellSortable":"HeadCell_HeadCellSortable__dk-+j"};